/** @format */

import React, { Component, Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import { Spin } from 'antd';
import { connect } from 'react-redux';
import { connectContext } from '@/components/Context';

import AnimatedSwitch from '@/components/AnimatedSwitch';

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.sendDustLogInstance = this.props.context.sendDustLogInstance;
  }

  componentWillMount() {
    this.sendDustLogInstance.updateData(
      {},
      {
        userId: this.props.userId,
        username: this.props.username,
      },
    );
    this.sendDustLogInstance.addData({
      userId: this.props.userId,
      username: this.props.username,
    });
  }

  render() {
    // React 16.6 or higher
    // 使用Suspense做Code-Splitting
    // https://github.com/rocky-191/react-juejin/issues/1
    const withSuspense = Component => props => (
      <Suspense fallback={<Spin />}>
        <Component {...props} />
      </Suspense>
    );

    const Home = withSuspense(lazy(() => import('../home/index')));
    const About = withSuspense(lazy(() => import('../about/index')));
    const Jobs = withSuspense(lazy(() => import('../jobs/index')));
    const User = withSuspense(lazy(() => import('../user/index')));
    const Post = withSuspense(lazy(() => import('../post/index')));
    const Paper = withSuspense(lazy(() => import('../paper/index')));
    const Discovery = withSuspense(lazy(() => import('../discovery/index')));
    const Tag = withSuspense(lazy(() => import('../tag/index')));
    const ReadingList = withSuspense(
      lazy(() => import('../readingList/index')),
    );
    const SearchResult = withSuspense(
      lazy(() => import('../searchResult/index')),
    );
    const Redirect = withSuspense(lazy(() => import('../redirect/index')));
    const NoMatch_404 = withSuspense(lazy(() => import('../404/index')));

    return (
      <AnimatedSwitch>
        <Route exact path="/" component={Home} />
        <Route exact path="/about" component={About} />
        <Route exact path="/jobs" component={Jobs} />
        <Route path="/user/:userId" component={User} />
        <Route path="/post/:articleId" component={Post} />
        <Route path="/paper/:paperId" component={Paper} />
        <Route path="/discovery" component={Discovery} />
        <Route path="/tag" component={Tag} />
        <Route path="/reading-list" component={ReadingList} />
        <Route path="/search-result/:keyword" component={SearchResult} />
        <Route path="/redirect" component={Redirect} />
        <Route component={NoMatch_404} />
      </AnimatedSwitch>
    );
  }
}

const mapStateToProps = state => {
  return {
    userImage: state.userReducer.userImage,
    userId: state.userReducer.userId,
    username: state.userReducer.username,
    email: state.userReducer.email,
    signature: state.userReducer.signature,
  };
};

Main = connect(mapStateToProps)(Main);

export default connectContext(Main);
